import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

class JbRestockRequest extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.controller?.abort();
    this.controller = new AbortController();
    this.generation = 0;
    this.closest('.shopify-section, dialog')?.addEventListener(StandardEvents.productSelect, event => this.updateVariant(event), { signal: this.controller.signal });
    this.addEventListener('click', event => {
      if (!(event.target instanceof Element) || !event.target.closest('[data-restock-repeat]')) return;
      this.receipt = null;
      try { localStorage.removeItem(this.receiptKey); } catch {}
      this.showReceipt(false);
      this.querySelector('input[type="email"]')?.focus();
    }, { signal: this.controller.signal });
    window.addEventListener('storage', () => this.showReceipt(this.hasReceipt()), { signal: this.controller.signal });
    window.addEventListener('pageshow', () => this.showReceipt(this.hasReceipt()), { signal: this.controller.signal });
    const success = this.querySelector('[data-restock-success]');
    const url = new URL(window.location.href);
    const returnedVariant = url.searchParams.get('jb_restock_variant');
    const formId = this.querySelector('form')?.id;
    const confirmed = success?.dataset.serverSuccess === 'true' && (returnedVariant === this.variantId || (!returnedVariant && url.hash === `#${formId}`));
    if (confirmed) {
      this.receipt = Date.now();
      try { localStorage.setItem(this.receiptKey, String(this.receipt)); } catch {}
      url.searchParams.delete('contact_posted');
      url.searchParams.delete('jb_restock_variant');
      window.history.replaceState(window.history.state, '', url);
    }
    this.showReceipt(confirmed || this.hasReceipt());
    if (confirmed) {
      this.hidden = false;
      success?.focus({ preventScroll: true });
      this.scrollIntoView({ block: 'center' });
    }
  }

  get variantId() { return this.querySelector('[name="contact[variant_id]"]')?.value || ''; }
  get receiptKey() { return `jb-restock-receipt:${this.dataset.productId}:${this.variantId}`; }

  hasReceipt() {
    let receipt = this.receipt;
    try { receipt = Number(localStorage.getItem(this.receiptKey)) || receipt; } catch {}
    return Boolean(receipt && Date.now() >= receipt && Date.now() - receipt < 86400000);
  }

  showReceipt(received) {
    const success = this.querySelector('[data-restock-success]');
    const entry = this.querySelector('[data-restock-entry]');
    const description = this.querySelector('[data-restock-description]');
    const heading = this.querySelector('[data-restock-heading]');
    if (success) success.hidden = !received;
    if (entry) entry.hidden = received;
    if (description) description.hidden = received;
    if (heading) heading.textContent = received ? heading.dataset.successHeading : heading.dataset.requestHeading;
  }

  async updateVariant(event) {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const generation = ++this.generation;
    try {
      const { detail } = await event.promise;
      if (generation !== this.generation || !this.isConnected || !detail?.html) return;
      if (detail.newProduct) this.dataset.productId = detail.newProduct.id;
      else if (detail.productId && String(detail.productId) !== this.dataset.productId) return;
      const updated = [...detail.html.querySelectorAll('jb-restock-request')].find(element => element.dataset.blockId === this.dataset.blockId);
      if (!updated) return;
      this.hidden = updated.hidden || !detail.resource;
      const variant = this.querySelector('[data-restock-variant]');
      if (variant) variant.textContent = updated.querySelector('[data-restock-variant]')?.textContent || '';
      for (const input of this.querySelectorAll('[data-restock-context]')) {
        const next = [...updated.querySelectorAll('[data-restock-context]')].find(element => element.name === input.name);
        if (next) input.value = next.value;
      }
      const returnTo = this.querySelector('[name="return_to"]');
      const nextReturnTo = updated.querySelector('[name="return_to"]');
      if (returnTo && nextReturnTo) returnTo.value = nextReturnTo.value;
      this.receipt = null;
      this.showReceipt(this.hasReceipt());
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('[jb-restock-request] Variant update failed:', error);
    }
  }

  disconnectedCallback() {
    this.generation++;
    this.controller?.abort();
    super.disconnectedCallback();
  }
}

if (!customElements.get('jb-restock-request')) customElements.define('jb-restock-request', JbRestockRequest);
